import { Component, OnInit } from '@angular/core';

interface Page {
  icon: string;
  text: string;
  key: 'consultoria' | 'movil' | 'software';
}

@Component({
  selector: 'app-proyects',
  templateUrl: './proyects.component.html',
  styleUrls: ['./proyects.component.css'],
  standalone: false
})
export class ProyectsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

  selected: 'consultoria' | 'movil' | 'software' = 'consultoria';

  sections: Page[] = [
    {
      icon: 'assets/svg/interactive.svg',
      text: 'Proyecto de Consultoría',
      key: 'consultoria'
    },
    {
      icon: 'assets/svg/card.svg',
      text: 'Estrategia y crecimiento digital',
      key: 'movil'
    },
    {
      icon: 'assets/svg/computer.svg',
      text: 'Optimización de Experiencia Digital',
      key: 'software'
    }
  ];

  selectSection(section: 'consultoria' | 'movil' | 'software') {
    this.selected = section;
  }

}
